/** UI texts: the price chart and the account value chart. Each key must exist in both languages. */
export const chartsUi = {
  en: {
    "chart.open": "O",
    "chart.closed": "Closed",
    "chart.high": "H",
    "chart.low": "L",
    "chart.close": "C",
    "chart.line.bollingerUpper": "Bollinger upper ({n})",
    "chart.line.bollingerLower": "Bollinger lower ({n})",
    "chart.line.bollinger": "Bollinger middle ({n})",
    "chart.line.ema": "EMA {n}",
    "chart.volume": "Vol",
    "chart.priceAria": "Price chart",
    "chart.walker.pad": "Steer Illusman",
    "chart.walker.show": "Show the joystick",
    "chart.walker.hide": "Hide the joystick",
    "chart.walker.stick": "Joystick: drag to walk or fly, up to jump, hold up to fly, down on a candle to stamp",
    "chart.walker.blow": "Blow (B)",
    "chart.walker.stamp": "Stamp (↓ on a candle)",
    "chart.walker.smoke": "Smoke break (J)",
    "chart.walker.throw": "Throw money (M, hold for more)",
  } as Record<string, string>,
  de: {
    "chart.open": "E",
    "chart.closed": "Geschlossen",
    "chart.high": "H",
    "chart.low": "T",
    "chart.close": "S",
    "chart.line.bollingerUpper": "Bollinger oben ({n})",
    "chart.line.bollingerLower": "Bollinger unten ({n})",
    "chart.line.bollinger": "Bollinger Mitte ({n})",
    "chart.line.ema": "EMA {n}",
    "chart.volume": "Vol.",
    "chart.priceAria": "Kursdiagramm",
    "chart.walker.pad": "Illusman steuern",
    "chart.walker.show": "Joystick einblenden",
    "chart.walker.hide": "Joystick ausblenden",
    "chart.walker.stick": "Joystick: ziehen zum Laufen oder Fliegen, nach oben zum Springen, nach oben halten zum Fliegen, auf einer Kerze nach unten zum Stampfen",
    "chart.walker.blow": "Pusten (B)",
    "chart.walker.stamp": "Stampfen (↓ auf einer Kerze)",
    "chart.walker.smoke": "Rauchpause (J)",
    "chart.walker.throw": "Geld werfen (M, halten für mehr)",
  } as Record<string, string>,
};
